import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Switch } from '@reveni-io/reveni-ui'

import CurrencySelector from '@/common/components/CurrencySelector/CurrencySelector'
import { feeTypes } from '@/configuration/pages/ConfigurationPage/LogisticsConfiguration/DeliveryMethods/DeliveryMethodDetailConfiguration/constants'

import ExtraFeeInput from './ExtraFeeInput/ExtraFeeInput'
import { handleChangeCurrency, handleChangeExtraFee, shouldShowExtraFeeAdditionalTransaction } from './helpers'
import * as Styles from './styles'

const FeeConfiguration = ({ config, defaultStoreCurrency, onChange, currencies, disabled }) => {
  const { t } = useTranslation()
  const [showExtraFeeAdditionalTransaction, setShowExtraFeeAdditionalTransaction] = useState(
    shouldShowExtraFeeAdditionalTransaction({
      extraFeeType: config?.extra_fee_type,
      extraAdditionalFee: config?.extra_fee_additional_transaction,
      baseExtraAdditionalFee: config?.base_extra_fee_additional_transaction,
    })
  )

  const handleShowExtraFeeAdditionalTransaction = checked => {
    setShowExtraFeeAdditionalTransaction(checked)
    if (!checked) {
      onChange({
        ...config,
        extra_fee_additional_transaction: '0',
        base_extra_fee_additional_transaction: '0',
        extra_fee_included_items_additional_transaction: '1',
      })
    }
  }

  return (
    <Styles.SectionContainer>
      <CurrencySelector
        selectedCurrency={config?.currency || defaultStoreCurrency}
        currencies={currencies}
        onChange={currency => handleChangeCurrency(currency, onChange)}
        disabled={disabled}
      />
      <ExtraFeeInput
        extraFee={config?.extra_fee}
        baseFee={config?.base_extra_fee}
        includedItems={config?.extra_fee_included_items}
        onChangeBaseFee={value => handleChangeExtraFee(value, 'base_extra_fee', onChange)}
        onChangeExtraFee={value => handleChangeExtraFee(value, 'extra_fee', onChange)}
        onChangeIncludedItems={value => handleChangeExtraFee(value, 'extra_fee_included_items', onChange)}
        currency={config?.currency || defaultStoreCurrency}
        currencies={currencies}
        extraFeeType={config?.extra_fee_type || feeTypes.flatFee}
        isAdditionalExtraFeeActive={showExtraFeeAdditionalTransaction}
        disabled={disabled}
      />
      <Switch
        label={t('Usar otro coste para las transacciones adicionales')}
        checked={showExtraFeeAdditionalTransaction}
        onChange={event => handleShowExtraFeeAdditionalTransaction(event.target.checked)}
        disabled={disabled}
      />
      {showExtraFeeAdditionalTransaction && (
        <ExtraFeeInput
          extraFee={config?.extra_fee_additional_transaction}
          baseFee={config?.base_extra_fee_additional_transaction}
          includedItems={config?.extra_fee_included_items_additional_transaction}
          onChangeBaseFee={value => handleChangeExtraFee(value, 'base_extra_fee_additional_transaction', onChange)}
          onChangeExtraFee={value => handleChangeExtraFee(value, 'extra_fee_additional_transaction', onChange)}
          onChangeIncludedItems={value =>
            handleChangeExtraFee(value, 'extra_fee_included_items_additional_transaction', onChange)
          }
          currency={config?.currency || defaultStoreCurrency}
          currencies={currencies}
          extraFeeType={config?.extra_fee_type || feeTypes.flatFee}
          isAdditionalExtraFeeActive={showExtraFeeAdditionalTransaction}
          isAdditionalFee
          disabled={disabled}
        />
      )}
    </Styles.SectionContainer>
  )
}

export default FeeConfiguration
